const MESSAGES = {
  FIRST_START: "Начни игру!", // При первом запуске страницы

  START: "Расшифруй загадку.", //начало игры после нажатия "Начать игру" и при "играть ещё"

  //сообщения ввода строк и реакция при проверке
  ENTER_LINE: "Введи текст для проверки.", // если строка ввода строчек пустая
  LINE_CORRECT: "Верно.", // отгаданная строка верная
  LINE_WRONG: "Неверно! Попробуй ещё раз.", //если предложение в строке не верное
  ALL_LINES_CORRECT: "Загадка расшифрована! Напиши ответ.", // все строчки расшифрованы

  //сообщения ввода разгадки (ответа)
  ENTER_ANSWER: "Введите ответ для проверки.", // если пустое поле ввода ответа
  ANSWER_WRONG: "Неверный ответ! Попробуй ещё раз", // если ответ на загадку неверный
  ANSWER_ALREADY_FOUND: "Это слово уже отгадано. Попробуй ещё раз.", // если слово уже было отгадано

  ROUND_FINISHED: "Поздравляем! Ты разгадал загадку. Нажми «Далее».", // когда загадка правильная разгадана
  GAME_FINISHED: "Все загадки разгаданы! Нажми «Играть ещё».", // когда все раунды с загадками разгаданы

  ENTER_TYPE2:"Слово найдено. Продолжай дальше.",
  START_TYPE2: "Прочитай секретные сообщения. Для выделения клетки щелкни по ней",

} as const;

export default MESSAGES;